<template>
	<div class="area">
		<div class="head">
	    <span class="head-tag"></span>
	    {{title}}
	  </div>
    <div class="block">
      <slot></slot>
    </div>    
  </div>
</template>

<script>
export default {
	data () {
		return {

		}
	},
	props:{
		title: String
	}
}
</script>

<style>
.area{
	border: 1px solid #cccccc;
	padding: 20px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
	margin-bottom: 15px
}
.head{
  margin: 0 5px 15px 5px
}

.head-tag{
  display: inline-block;
  background-color: #5ab1f0;
  width: 5px;
  height: 21px;
  vertical-align: top;
  margin-right: 10px
}
</style>


// WEBPACK FOOTER //
// src/components/common/PanelForItem.vue